import { useDispatch } from "react-redux";
import { trackEventForAdoption } from "src/legacy/redux/actions/adoption";

export const useTourAdoption = () => {

  const dispatch: any = useDispatch();

  const trackTourEvent = (eventName) => {

    const event = {
      event: eventName,
      properties: {
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  return {
    trackTourEvent
  }

}